import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import styles from '../styles/EmptyPDP.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import { getAccountLabelsNew } from './EmptyPDP.labels';
import { renderLabel } from '../../../../../../../utils/labels/labelUtilty';

const EmptyPDP = ({ className }) => {
  const accountLabels = getAccountLabelsNew();
  useEffect(() => {
    document.getElementById('web-app-content')?.classList?.remove('mainPageHeight');
    window?.scrollTo(0, 0);
    return () => document.getElementById('web-app-content')?.classList?.add('mainPageHeight');
  }, []);
  return (
    <div className={className}>
      <div className="empty-pdp-container">
        <BodyCopy
          component="span"
          fontWeight="extrabold"
          fontFamily="secondary"
          className="elem-mb-SM header"
          textAlign="center"
        >
          {renderLabel(
            accountLabels.lbl_order_history_product_unavailable_header,
            'lbl_order_history_product_unavailable_header'
          )}
        </BodyCopy>
        <Button
          type="button"
          buttonVariation="variable-width"
          dataLocator="viewOrderDetails"
          className="elem-mt-XL back-cta"
          fill="BLUE"
          fontSize="fs14"
          onClick={() => window?.history?.back()}
        >
          {renderLabel(
            accountLabels.lbl_order_history_product_back_cta,
            'lbl_order_history_product_back_cta'
          )}
        </Button>
      </div>
    </div>
  );
};

EmptyPDP.propTypes = {
  className: PropTypes.string,
};

EmptyPDP.defaultProps = {
  className: '',
};

export default withStyles(EmptyPDP, styles);
export { EmptyPDP as EmptyPDPVanilla };
